import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";

function TelegramNotificationsPanel() {
  const { request, showStatus } = useApi();

  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [testing, setTesting] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    chat_id: '',
    event_types: [],
    min_priority: '',
    enabled: true
  });

  const EVENT_TYPES = [
    { value: 'new_ticket', label: '🎫 Новые тикеты' },
    { value: 'new_message', label: '💬 Новые сообщения' },
    { value: 'referral_withdrawal', label: '💰 Выводы реферальных' },
    { value: 'automation_alert', label: '🔴 Аварии автоматизаций (цена ниже минимума)' }
  ];

  const PRIORITY_LEVELS = [
    { value: '', label: 'Все приоритеты' },
    { value: 'low', label: 'От низкого и выше' },
    { value: 'normal', label: 'От среднего и выше' },
    { value: 'high', label: 'Только высокий' }
  ];

  useEffect(() => {
    loadChannels();
  }, []);

  const loadChannels = async () => {
    setLoading(true);
    try {
      const data = await request('/api/v1/admin/telegram/channels');
      setChannels(data.channels || []);
    } catch (e) {
      logger.error('Ошибка загрузки каналов', e);
      showStatus('error', 'Не удалось загрузить каналы');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      chat_id: '',
      event_types: [],
      min_priority: '',
      enabled: true
    });
    setEditingId(null);
  };

  const handleAddClick = () => {
    resetForm();
    setShowForm(true);
  };

  const handleEditClick = (channel) => {
    setFormData({
      name: channel.name,
      chat_id: channel.chat_id,
      event_types: channel.event_types || [],
      min_priority: channel.min_priority || '',
      enabled: channel.enabled
    });
    setEditingId(channel.id);
    setShowForm(true);
  };

  const handleEventTypeToggle = (eventType) => {
    setFormData(prev => ({
      ...prev,
      event_types: prev.event_types.includes(eventType)
        ? prev.event_types.filter(t => t !== eventType)
        : [...prev.event_types, eventType]
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      showStatus('error', 'Укажите название канала');
      return;
    }
    if (!formData.chat_id.trim()) {
      showStatus('error', 'Укажите Chat ID');
      return;
    }
    if (formData.event_types.length === 0) {
      showStatus('error', 'Выберите хотя бы одно событие');
      return;
    }

    try {
      if (editingId) {
        // Редактирование
        await request(`/api/v1/admin/telegram/channels/${editingId}`, {
          method: 'PUT',
          body: JSON.stringify(formData)
        });
        showStatus('success', 'Канал обновлён');
      } else {
        // Создание
        await request('/api/v1/admin/telegram/channels', {
          method: 'POST',
          body: JSON.stringify(formData)
        });
        showStatus('success', 'Канал добавлен');
      }
      setShowForm(false);
      await loadChannels();
    } catch (e) {
      logger.error('Ошибка сохранения', e);
      showStatus('error', 'Ошибка при сохранении');
    }
  };

  const handleDelete = async (channelId) => {
    if (!window.confirm('Удалить канал?')) return;

    try {
      await request(`/api/v1/admin/telegram/channels/${channelId}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Канал удален');
      await loadChannels();
    } catch (e) {
      logger.error('Ошибка удаления', e);
      showStatus('error', 'Ошибка при удалении');
    }
  };

  const handleTest = async (channelId) => {
    setTesting(channelId);
    try {
      const result = await request(`/api/v1/admin/telegram/channels/${channelId}/test`, {
        method: 'POST'
      });
      showStatus('success', result.message || 'Тестовое сообщение отправлено');
    } catch (e) {
      logger.error('Ошибка тестирования', e);
      showStatus('error', 'Ошибка при отправке тестового сообщения');
    } finally {
      setTesting(null);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h2 style={{ margin: 0 }}>🔔 Telegram Уведомления</h2>
          <p style={{ color: '#666', fontSize: '14px', margin: '5px 0 0 0' }}>
            Управление каналами для отправки уведомлений о тикетах поддержки
          </p>
        </div>
        <button
          onClick={handleAddClick}
          style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ➕ Добавить канал
        </button>
      </div>

      {/* Форма */}
      {showForm && (
        <div style={{
          background: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '20px'
        }}>
          <h3>{editingId ? 'Редактировать канал' : 'Новый канал'}</h3>
          <form onSubmit={handleSave}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Название канала
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Например: Support Team"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Chat ID группы в Telegram
              </label>
              <input
                type="text"
                value={formData.chat_id}
                onChange={(e) => setFormData({ ...formData, chat_id: e.target.value })}
                placeholder="Например: -1001234567890"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxSizing: 'border-box'
                }}
              />
              <p style={{ fontSize: '12px', color: '#666', margin: '5px 0 0 0' }}>
                Для приватной группы: отрицательное число (например, -1001234567890)
              </p>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
                События
              </label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {EVENT_TYPES.map(event => (
                  <label key={event.value} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={formData.event_types.includes(event.value)}
                      onChange={() => handleEventTypeToggle(event.value)}
                      style={{ marginRight: '8px', cursor: 'pointer' }}
                    />
                    {event.label}
                  </label>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                Минимальный приоритет
              </label>
              <select
                value={formData.min_priority}
                onChange={(e) => setFormData({ ...formData, min_priority: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxSizing: 'border-box'
                }}
              >
                {PRIORITY_LEVELS.map(level => (
                  <option key={level.value} value={level.value}>
                    {level.label}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={formData.enabled}
                  onChange={(e) => setFormData({ ...formData, enabled: e.target.checked })}
                  style={{ marginRight: '8px', cursor: 'pointer' }}
                />
                Включен
              </label>
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="submit"
                style={{
                  background: '#28a745',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                ✓ Сохранить
              </button>
              <button
                type="button"
                onClick={() => setShowForm(false)}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                ✕ Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Таблица каналов */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <span>Загрузка...</span>
        </div>
      ) : channels.length === 0 ? (
        <div style={{
          background: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '4px',
          padding: '15px',
          textAlign: 'center',
          color: '#856404'
        }}>
          Нет настроенных каналов. Добавьте первый канал для получения уведомлений.
        </div>
      ) : (
        <div style={{
          background: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
              <tr>
                <th style={{ padding: '12px', textAlign: 'left' }}>Название</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Chat ID</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>События</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Приоритет</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Статус</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {channels.map(channel => (
                <tr key={channel.id} style={{ borderBottom: '1px solid #e9ecef' }}>
                  <td style={{ padding: '12px', fontWeight: 'bold' }}>{channel.name}</td>
                  <td style={{ padding: '12px', fontFamily: 'monospace', fontSize: '12px' }}>
                    {channel.chat_id}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <div style={{ fontSize: '12px' }}>
                      {channel.event_types.map(type => {
                        const eventLabel = EVENT_TYPES.find(e => e.value === type)?.label || type;
                        return <div key={type}>{eventLabel}</div>;
                      })}
                    </div>
                  </td>
                  <td style={{ padding: '12px', textAlign: 'center', fontSize: '12px' }}>
                    {channel.min_priority
                      ? PRIORITY_LEVELS.find(p => p.value === channel.min_priority)?.label
                      : 'Все'}
                  </td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      background: channel.enabled ? '#d4edda' : '#f8d7da',
                      color: channel.enabled ? '#155724' : '#721c24'
                    }}>
                      {channel.enabled ? '✓ Активен' : '✕ Отключен'}
                    </span>
                  </td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                      <button
                        onClick={() => handleTest(channel.id)}
                        disabled={testing === channel.id}
                        style={{
                          background: '#17a2b8',
                          color: 'white',
                          border: 'none',
                          padding: '6px 10px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          opacity: testing === channel.id ? 0.6 : 1
                        }}
                        title="Отправить тестовое сообщение"
                      >
                        {testing === channel.id ? '...' : '🧪'}
                      </button>
                      <button
                        onClick={() => handleEditClick(channel)}
                        style={{
                          background: '#ffc107',
                          color: 'black',
                          border: 'none',
                          padding: '6px 10px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                        title="Редактировать"
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => handleDelete(channel.id)}
                        style={{
                          background: '#dc3545',
                          color: 'white',
                          border: 'none',
                          padding: '6px 10px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                        title="Удалить"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default TelegramNotificationsPanel;
